import moment from 'moment/moment';
import { store } from '../../../store/store';

// Functions for all exports.
const calcBarWidth = (value, chartWidth, page) => {
  const maxValue = (store.getters.dataFormat === 'percentage'
    ? store.getters[`$_${page}/${page === 'performance' ? 'pI' : page}PageMaxPercent`]
    : store.getters[`$_${page}/${page === 'performance' ? 'pI' : page}PageMaxDecimal${page === 'summary' ? 'Overall' : ''}`]);
  console.log(`$_${page}/${page === 'performance' ? 'pI' : page}PageMaxPercent`);
  const valueAsPercentOfMaxValue = (value / maxValue) * 100;
  return (chartWidth / 100) * valueAsPercentOfMaxValue;
};

const calculateNextLegendX = (string, currentX) => {
  const stringLength = string.length;
  let letterWidth;

  if (stringLength < 4) {
    letterWidth = 3;
  }

  if (stringLength >= 4 && stringLength <= 10) {
    letterWidth = 4;
  }

  if (stringLength >= 11 && stringLength <= 16) {
    letterWidth = 5;
  }

  if (stringLength > 16) {
    letterWidth = 4.5;
  }

  return currentX + (stringLength * letterWidth) + 50;
};

const calculateTitleXOffset = (string) => {
  const stringLength = string.length;
  let offSet;
  let letterWidth;

  if (stringLength < 4) {
    offSet = 565;
    letterWidth = 14;
  }

  if (stringLength >= 4 && stringLength <= 10) {
    offSet = 570;
    letterWidth = 12;
  }

  if (stringLength >= 11 && stringLength <= 16) {
    offSet = 575;
    letterWidth = 10;
  }

  if (stringLength > 16) {
    offSet = 570;
    letterWidth = 10;
  }

  return offSet - (stringLength * letterWidth);
};

const generatePDFfileName = () => {
  const { currentPage } = store.getters;
  const { pageTitle } = store.getters;
  const filenameDate = moment().format('YYYY-MM-DD-HH-mm-ss');
  return `${currentPage}-Report-${pageTitle}-${filenameDate}.pdf`;
};

const hex2rgb = (hex) => {
  let rgb = hex.replace('#', '');
  rgb = rgb.match(new RegExp(`(.{${rgb.length / 3}})`, 'g'));
  for (let i = 0; i < rgb.length; i += 1) {
    rgb[i] = parseInt(rgb[i].length === 1 ? rgb[i] + rgb[i] : rgb[i], 16);
  }
  return { r: rgb[0], g: rgb[1], b: rgb[2] };
};

// Functions just for summary exports
const calculateCategoryDataX = (string) => {
  const stringLength = string.length;
  const offSet = 320;
  const letterWidth = 4;

  return offSet - (stringLength * letterWidth);
};

const formatFlagBreakdownData = (data) => {
  const percentage = (store.getters.dataFormat === 'percentage' ? '%' : '');
  let formattedData = '';
  if (data === 'N/A') {
    formattedData = data;
  } else {
    formattedData = `${data}${percentage}`;
  }
  return formattedData;
};

const parseSummaryArray = (array) => {
  let baseLabelString;
  let compLabelString;
  let baseString;
  let compString;
  const percentage = (store.getters.dataFormat === 'percentage' ? '%' : '');
  const decimalPlaces = (store.getters.dataFormat === 'percentage' ? 1 : 0);

  if (typeof array[0] === 'number') {
    baseLabelString = `${array[0].toFixed(decimalPlaces).toString()}${percentage}`;
    baseString = array[0].toFixed(decimalPlaces);
  } else {
    baseLabelString = 'N/A';
    baseString = '';
  }

  if (typeof array[1] === 'number') {
    compLabelString = `${array[1].toFixed(decimalPlaces).toString()}${percentage}`;
    compString = array[1].toFixed(decimalPlaces);
  } else {
    compLabelString = 'N/A';
    compString = '';
  }

  return {
    baseLabel: baseLabelString,
    compLabel: compLabelString,
    base: baseString,
    comp: compString,
  };
};

// Functions for Industry Overview

const calculateBadgeOffset = (string) => {
  const stringLength = string.length;
  let offSet;

  if (stringLength === 1) {
    offSet = 7.5;
  } else if (stringLength === 2) {
    offSet = 4.5;
  }

  return offSet;
};

const formatLabel = (string, organisationPos) => {
  let returnValue;
  const rareMode = store.getters.clientOrRareMode;
  const currentClient = store.getters.getDisplayNameFromUsername(string);

  if (string.includes('industry')) {
    returnValue = 'Industry Average';
  } else if (rareMode) {
    returnValue = store.getters.getDisplayNameFromUsername(string);
  } else if (!rareMode && string !== currentClient) {
    returnValue = `${currentClient}`;
  } else {
    returnValue = `Organisation ${organisationPos}`;
  }

  return returnValue;
};

const formatDataLabel = (string) => {
  let returnValue;
  if (string === 'N/A') {
    returnValue = string;
  } else if (string === 'industry_average') {
    returnValue = 'Industry Average';
  } else {
    const percentage = (store.getters.dataFormat === 'percentage' ? '%' : '');
    returnValue = `${string}${percentage}`;
  }

  return returnValue;
};

export {
  calcBarWidth,
  calculateCategoryDataX,
  calculateBadgeOffset,
  calculateNextLegendX,
  calculateTitleXOffset,
  formatDataLabel,
  formatFlagBreakdownData,
  formatLabel,
  generatePDFfileName,
  hex2rgb,
  parseSummaryArray,
};
